import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
// import { register as registerUser  } from '../features/authSlice';
import { getAllStates, getAllCities, getPincodeDetails, updateTechnician, addTechnician } from '../features/technicianSlice';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/AddTechnicianModal.css';
import sidebarClose from '../assets/images/sidebar-close.svg';

const getSchema = (role) => {
  if (role === "ADMIN") {
    return yup.object().shape({
      firstName: yup
        .string()
        .required('First name is required')
        .matches(/^[A-Za-z]+$/, 'First name must contain only alphabets'),
      lastName: yup
        .string()
        .required('Last name is required')
        .matches(/^[A-Za-z]+$/, 'Last name must contain only alphabets'),
      email: yup.string().email('Invalid email').required('Email is required'),
      phone: yup.string()
    });
  } else {
    return yup.object().shape({
      firstName: yup
        .string()
        .required('First name is required')
        .matches(/^[A-Za-z]+$/, 'First name must contain only alphabets'),
      lastName: yup
        .string()
        .required('Last name is required')
        .matches(/^[A-Za-z]+$/, 'Last name must contain only alphabets'),
      email: yup.string().email('Invalid email').required('Email is required'),
      phone: yup.string()
        .required('Phone number is required')
        .matches(/^\d{10}$/, 'Phone number must be 10 digits')
        .test('is-numeric', 'Phone number must be numeric', value => /^\d+$/.test(value)),
      pincode: yup.string()
        .required('Pin code is required')
        .matches(/^\d{6}$/, 'Pin code must be 6 digits'),
      state: yup.string().required('State is required'),
      city: yup.string().required('City is required'),
      address: yup.string().required('Address is required'),
    });
  }
};

const AddTechnicianModal = ({ open, onClose, editMode = false, user, customTitle }) => {
  const dispatch = useDispatch();
  const role = user?.role || (customTitle === "Update Profile" ? "ADMIN" : "TECHNICIAN");
  const { register, handleSubmit, formState: { errors }, setValue, watch, reset } = useForm({ resolver: yupResolver(getSchema(role)) });
  const [loading, setLoading] = useState(false);
  const { states, cities, statesLoading, citiesLoading, pincodeDetails, pincodeDetailsError } = useSelector(state => state.technicians);

  useEffect(() => {
    if (open) {
      dispatch(getAllStates());
      dispatch(getAllCities());
    }
  }, [open, dispatch]);

  // Watch pincode field
  const pincode = watch('pincode');
  useEffect(() => {
    if (pincode && pincode.length === 6) {
      dispatch(getPincodeDetails(pincode));
    } else if (!pincode || pincode.length <= 5) {
      setValue('state', '');
      setValue('city', '');

    }
  }, [pincode, dispatch, setValue]);

  // Auto-select city/state when pincodeDetails changes
  useEffect(() => {
    if (pincodeDetails && pincodeDetails.city && pincodeDetails.state && pincode && pincode.length === 6) {
      // Find city and state by id
      const cityObj = cities.find(c => c.id === pincodeDetails.city.id || c._id === pincodeDetails.city.id);
      const stateObj = states.find(s => s.id === pincodeDetails.state.id || s._id === pincodeDetails.state.id);
      if (stateObj) setValue('state', stateObj.id || stateObj._id);
      if (cityObj) setValue('city', cityObj.id || cityObj._id);

    }
  }, [pincodeDetails, cities, states, setValue, pincode]);

  // Pre-fill form when user changes (edit mode)
  useEffect(() => {
    if (editMode && user && states.length && cities.length) {
      reset({
        firstName: user.firstname || '',
        lastName: user.lastname || '',
        email: user.email || '',
        phone: user.phone || '',
        pincode: user.zipCode || '',
        state: user?.stateId,
        city: user?.cityId,
        address: user.address || '',
      });
    } else if (!editMode && open) {
      // Reset form when switching to add mode
      reset({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        pincode: '',
        state: '',
        city: '',
        address: '',
      });
    }
  }, [editMode, user, states, cities, reset, open]);

  const onSubmit = async (data) => {
    setLoading(true);
    const payload = {
      ...data,
      firstname: data.firstName,
      lastname: data.lastName,
      role: customTitle ? data?.role : "TECHNICIAN",
    };
    // Only add these fields if role is TECHNICIAN
    if ((customTitle ? data?.role : "TECHNICIAN") === "TECHNICIAN") {
      payload.stateId = data.state;
      payload.cityId = data.city;
      payload.zipCode = data.pincode;
      payload.address = data.address;
    }
    // Only set password if adding technician (not updating profile)
    if (!editMode) {
      payload.password = "technician@123";
    }

    delete payload.firstName;
    delete payload.lastName;
    delete payload.state;
    delete payload.city;
    delete payload.pincode;

    try {
      if (editMode && user && user.id) {
        // Update technician
        const resultAction = await dispatch(updateTechnician({ id: user.id, data: payload }));
        if (updateTechnician.rejected.match(resultAction)) {
          toast.error(resultAction.payload || "Failed to update technician");
        } else {
          if (onClose) onClose("update");
          if(customTitle === "Update Profile"){
            toast.success('User updated successfully');
          }
        }
      } else {
        // Create technician
        const resultAction = await dispatch(addTechnician(payload));
        if (addTechnician.rejected.match(resultAction)) {
          toast.error(resultAction.payload || "Failed to create technician");
        } else {
          onClose('add');  // This should go to TechnicianList.handleModalClose
        }
      }
    } finally {
      setLoading(false);
    }
  };
  




  if (!open) return null;

  return (
    <div>
      {/* <div className='modal-wrapper'>
        <div className='content-wrapper'>
          <div className='header-modal'>
            <h2>{customTitle ? customTitle : (editMode ? 'Edit Technician' : 'Add Technician')}</h2>
            <button onClick={onClose}><img src={sidebarClose} alt="Close" /></button>
          </div>
        </div>
      </div> */}
      <div className="add-tech-modal-overlay">
        <div className="add-tech-modal slide-in">
          <button className="add-tech-modal-close" onClick={onClose}><img src={sidebarClose} alt="Close" /></button>
          <h2 className="add-tech-modal-title">{customTitle ? customTitle : (editMode ? 'Edit Technician' : 'Add Technician')}</h2>
          <form className="add-tech-modal-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="add-tech-modal-row">
              <div className="add-tech-modal-field">
                <label className='form-label'>First Name</label>
                <input className='form-input' type="text" placeholder="Enter first name" {...register('firstName')}
                  onInput={e => {
                    e.target.value = e.target.value.replace(/[^A-Za-z]/g, '');
                  }}
                />
                {errors.firstName && <span className="input-error">{errors.firstName.message}</span>}
              </div>
              <div className="add-tech-modal-field">
                <label className='form-label'>Last Name</label>
                <input className='form-input' type="text" placeholder="Enter last name" {...register('lastName')}
                  onInput={e => {
                    e.target.value = e.target.value.replace(/[^A-Za-z]/g, '');
                  }}
                />
                {errors.lastName && <span className="input-error">{errors.lastName.message}</span>}
              </div>
            </div>
            <div className="add-tech-modal-row">
              <div className="add-tech-modal-field">
                <label className='form-label'>E-mail</label>
                <input className='form-input' type="email" placeholder="Enter your E-mail" {...register('email')} disabled={editMode} />
                {errors.email && <span className="input-error">{errors.email.message}</span>}
              </div>
              {/* Only show phone number in same row if not ADMIN */}
              {((user && user.role !== "ADMIN") || (!user && (!customTitle || customTitle !== "Update Profile"))) && (
                <div className="add-tech-modal-field">
                  <label className='form-label'>Phone Number</label>
                  <input className='form-input' type="text" placeholder="Enter phone number" {...register('phone')}
                    onInput={e => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, '');
                    }}
                  />
                  {errors.phone && <span className="input-error">{errors.phone.message}</span>}
                </div>
              )}
            </div>
            {/* Only show extra fields if role is not ADMIN */}
            {((user && user.role !== "ADMIN") || (!user && (!customTitle || customTitle !== "Update Profile"))) && (
              <>
                <div className="add-tech-modal-row">
                  <div className="add-tech-modal-field" style={{ flex: 1 }}>
                    <label className='form-label'>Pin Code</label>
                    <input
                      className='form-input'
                      type="text"
                      placeholder="Enter pin code"
                      {...register('pincode')}
                      onInput={e => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                      }}
                      disabled={editMode}
                    />
                    {errors.pincode && <span className="input-error">{errors.pincode.message}</span>}
                    {pincodeDetailsError === 'Pincode not found' && (
                      <span className="input-error">Pincode not found</span>
                    )}
                  </div>
                </div>
                <div className="add-tech-modal-row">
                  <div className="add-tech-modal-field">
                    <label className='form-label'>State</label>
                    <select className='form-input auto-filled'  {...register('state')} disabled>
                      <option value="">Select state</option>
                      {statesLoading || !states.length ? null : (
                        states.map((state) => (
                          <option key={state.id || state._id || state.name} value={state.id || state._id}>{state.name || state.id || state._id}</option>
                        ))
                      )}
                    </select>
                    {errors.state && !watch('state') === '' ? <span className="input-error">{errors.state.message}</span> : null}
                    {/* state is always disabled; validation error suppressed */}
                  </div>
                  <div className="add-tech-modal-field">
                    <label className='form-label'>City</label>
                    <select className='form-input auto-filled' {...register('city')} disabled>
                      <option value="">Select city</option>
                      {citiesLoading || !cities.length ? null : (
                        cities.map((city) => (
                          <option key={city.id || city._id || city.name} value={city.id || city._id}>{city.name || city.id || city._id}</option>
                        ))
                      )}
                    </select>
                    {errors.city && !watch('city') === '' ? <span className="input-error">{errors.city.message}</span> : null}
                    {/* city is always disabled; validation error suppressed */}
                  </div>
                </div>
                <div className="add-tech-modal-row">
                  <div className="add-tech-modal-field" style={{ flex: 1 }}>
                    <label className='form-label'>Address</label>
                    <textarea className='form-input' placeholder="Enter your street address, apartment, suite, etc" {...register('address')} rows={2} />
                    {errors.address && <span className="input-error">{errors.address.message}</span>}
                  </div>
                </div>
              </>
            )}
            <div className="add-tech-modal-actions">
              <button type="button" className="cancel-btn" onClick={onClose} disabled={loading}>Cancel</button>
              <button type="submit" className="add-btn" disabled={loading}>
                {loading ? (
                  <>
                    
                    {editMode ? (customTitle ? 'Updating...' : 'Updating...') : 'Adding...'}
                  </>
                ) : (
                  editMode ? (customTitle ? 'Update' : 'Update') : 'Add'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddTechnicianModal;
